import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "./utils/rem";
import "./assets/index.less";
import 'vant/lib/index.css';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
// 完整加载
import VueLuckyCanvas from '@lucky-canvas/vue';
import vue3SeamlessScroll from "vue3-seamless-scroll";
createApp(App).use(router).use(ElementPlus).use(VueLuckyCanvas).use(vue3SeamlessScroll).mount("#app");